module.exports = __webpack_public_path__ + "static/api-relay-race-a48e67a0a781cf713775bf52df6d13d8.svg";